import { asCouponPayment, CouponPayment } from "@goodfill/domain-properties";
import {
  MultiselectColumnDefinition,
  MultiselectCriteria,
  multiselectFilter,
  MultiselectFilterChangeFunction,
} from "../generic/MultiselectColumnDefinition";
import { createFiniteDecimalFromAnyString } from "@goodfill/decimal";
import { CouponPaymentComponent, formatCouponPayment } from "@goodfill/domain-properties-components";
import { arrayUnique } from "@goodfill/array";
import { decimalComparator } from "@goodfill/sort";

export const COUPON_PAYMENT_CRITERIA_KEY = "couponPayment";

export function getSortedBondCouponPayments<TItemKey extends string>(
  key: TItemKey,
  rows: Array<{
    [key in TItemKey]: CouponPayment;
  }>,
) {
  const values = arrayUnique(
    rows.map((row) => row[key]),
    (a, b) => a.equals(b),
  );
  values.sort(decimalComparator);

  return values;
}

export const couponPaymentFilter = <TItemKey extends string>(key: TItemKey) =>
  multiselectFilter(COUPON_PAYMENT_CRITERIA_KEY, key, (a: CouponPayment, b: CouponPayment) => a.equals(b));

export const CouponPaymentColumnDefinition = <K extends string>(
  key: K,
  criteria: MultiselectCriteria<typeof COUPON_PAYMENT_CRITERIA_KEY, CouponPayment>,
  onFilterChange: MultiselectFilterChangeFunction<typeof COUPON_PAYMENT_CRITERIA_KEY, CouponPayment>,
  bondCouponsPayments: CouponPayment[],
) =>
  MultiselectColumnDefinition(
    "Coupon",
    key,
    COUPON_PAYMENT_CRITERIA_KEY,
    criteria,
    onFilterChange,
    bondCouponsPayments,
    (a: CouponPayment) => formatCouponPayment({ value: a }),
    (a) => asCouponPayment(createFiniteDecimalFromAnyString(a.replace("%", ""), COUPON_PAYMENT_CRITERIA_KEY).div(100)),
    170,
    (row) => <CouponPaymentComponent value={row[key]} />,
  );
